import { render, staticRenderFns } from "./supplierJGJ.vue?vue&type=template&id=3ee19f15&scoped=true&"
import script from "./supplierJGJ.vue?vue&type=script&lang=js&"
export * from "./supplierJGJ.vue?vue&type=script&lang=js&"
import style0 from "./supplierJGJ.vue?vue&type=style&index=0&id=3ee19f15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee19f15",
  null
  
)

export default component.exports